import VouchersBalance from '@/components/VouchersBalance'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: VouchersBalance
	}

	let page = vuewidget(dom, options)
	return page
}
